import { useEffect } from 'react';
import formEventHandler from '../services/FormEventHandler';

/**
 * A utility hook to explicitly mount and register hooks 
 * with the FormEventHandler when needed
 * 
 * @param {string} hookType - The type of hook to register (e.g., 'customer_login')
 * @param {Object} hookInstance - The hook instance with methods to register
 */
export const useHookMount = (hookType, hookInstance) => {
  useEffect(() => {
    // Directly register with FormEventHandler
    if (formEventHandler) {
      console.log(`[useHookMount] Manually registering ${hookType} hook`);
      
      if (typeof formEventHandler.registerHook === 'function') {
        // Direct registration without going through events
        formEventHandler.registerHook({
          detail: { hookType, hookInstance }
        });
      }
    }
    
    // Also dispatch the event for redundancy
    console.log(`[useHookMount] Dispatching registration event for ${hookType}`);
    window.dispatchEvent(new CustomEvent('hookRegistered', {
      detail: {
        hookType,
        hookInstance
      }
    }));
    
    return () => {
      console.log(`[useHookMount] Unmounting ${hookType} hook`);
      
      // Direct unregistration
      if (formEventHandler && typeof formEventHandler.unregisterHook === 'function') {
        formEventHandler.unregisterHook({
          detail: { hookType }
        });
      }
      
      // Event-based unregistration
      window.dispatchEvent(new CustomEvent('hookUnregistered', {
        detail: { hookType }
      }));
    };
  }, [hookType, hookInstance]);
};

export default useHookMount;